export function generateQueryFromIds(ids: number[]): string {
    return ids.length ? `ids=${ids.join('&ids=')}` : '';
}
